// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"src_views_Bridge_Jitsi_vue":"75250d0f","src_views_Bridge_index_vue":"4be99e71","src_views_Layout_vue":"91351744"}[chunkId] + ".js";
};